import React, { useState, useContext } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { store } from './Driver';
import { store as mainStore } from '../../../../../../store';
import axios from '../../../../../../api/axios';
import { useParams } from 'react-router-dom';
import Chip from '@material-ui/core/Chip';
import formatNumber from '../../../../../../fns/formatNumber';
import dotsLoader from '../../../../../../assets/svg/dotsLoader.svg';
import red from '@material-ui/core/colors/red';
import green from '@material-ui/core/colors/lightGreen';
import useRules from '../../../../../../hooks/useRules';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {},
  addBtn: {
    background: 'linear-gradient(45deg, #8bc34a 30%, #cddc39 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 2px 3px 1px #b3e4b540',
    color: 'white',
    height: 30,
    padding: '0 30px',
  },
  removeBtn: {
    background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
    border: 0,
    borderRadius: 3,
    boxShadow: '0 2px 3px 1px rgba(255, 105, 135, .3)',
    color: 'white',
    height: 30,
    padding: '0 30px',
  },
  green: {
    background: green[300],
  },
  red: {
    background: red[300],
  },
}));

const Wallet = () => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const initialState = { amount: '', description: '' };
  const { id: userId } = useParams();
  const [values, setValues] = useState(initialState);
  const { amount, description } = values;
  const [error, setError] = useState({});
  const { showMessage, showError } = useContext(mainStore);
  const { state, dispatch } = useContext(store);
  const { fetchingTransactions, transactions } = state;
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    let { name, value } = e.target;
    setValues({ ...values, [name]: value });
  };
  const validation = (e) => {
    const isSingleValidation = e || false;
    let er = {};

    // Validation patterns start here:
    if (!amount || amount <= 0) {
      er.amount = 'مبلغ بایستی یک عدد مثبت رند باشد.';
    }
    if (!description || description.length < 3) {
      er.description = 'توضیحات تراکنش بایستی حداقل ۳ کاراکتر داشته باشد.';
    }

    // Validation patterns end here.

    if (isSingleValidation) {
      let err = {};

      for (const v in values) {
        if (values[v]) {
          if (er[v]) {
            err[v] = er[v];
          }
        }
      }
      if (Object.entries(err).length) {
        setError(err);
        return false;
      } else {
        setError({});
        return true;
      }
    } else {
      if (Object.entries(er).length) {
        setError(er);
        return false;
      }
      setError(er);
      return true;
    }
  };
  const handleAddCredit = async () => {
    if (validation()) {
      try {
        setLoading(true);
        const { data } = await axios.post(`/api/v1/admin/users/addCredit`, {
          userId,
          amount,
          description,
        });
        showMessage(data.messages);
        const res = await fetchingTransactions(
          userId,
          transactions.page,
          transactions.limit
        );
        dispatch({
          type: 'LOAD',
          payload: { name: 'transactions', value: res },
        });
        setValues(initialState);
      } catch (error) {
        showError(error);
      }
      setLoading(false);
    } else {
      setLoading(false);
      showError('خطاهای مشخص شده را برطرف نمائید.');
    }
  };
  const handleCreditDeduction = async () => {
    if (validation()) {
      try {
        setLoading(true);
        const { data } = await axios.post(
          `/api/v1/admin/users/creditDeduction`,
          {
            userId,
            amount,
            description,
          }
        );
        showMessage(data.messages);
        const res = await fetchingTransactions(
          userId,
          transactions.page,
          transactions.limit
        );
        dispatch({
          type: 'LOAD',
          payload: { name: 'transactions', value: res },
        });
        setValues(initialState);
      } catch (error) {
        showError(error);
      }
      setLoading(false);
    } else {
      setLoading(false);
      showError('خطاهای مشخص شده را برطرف نمائید.');
    }
  };
  return (
    <div className={classes.root}>
      <Grid container direction="column" spacing={1}>
        {hasRule('can_see_wallet_balance') && (
          <Grid item>
            <Typography component="h2" variant="h2">
              کیف پول:
            </Typography>
          </Grid>
        )}
        {hasRule('can_see_wallet_balance') && (
          <Grid item>
            {transactions && transactions.totalAmount !== undefined ? (
              <Chip
                className={
                  transactions.totalAmount >= 0 ? classes.green : classes.red
                }
                label={formatNumber(transactions.totalAmount) + ' تومان'}
              />
            ) : (
              <Chip label={<img width={50} src={dotsLoader} alt="" />} />
            )}
          </Grid>
        )}
        {hasRule('can_change_users_wallet_balance') && (
          <>
            <Grid item>
              <TextField
                type="number"
                fullWidth
                label="مبلغ"
                variant="outlined"
                color="primary"
                size="small"
                name="amount"
                value={amount}
                onChange={handleChange}
                error={error.amount ? true : false}
                helperText={error.amount ? error.amount : ''}
                onBlur={validation}
              />
            </Grid>
            <Grid item>
              <TextField
                fullWidth
                label="بابت"
                variant="outlined"
                color="primary"
                size="small"
                name="description"
                value={description}
                onChange={handleChange}
                error={error.description ? true : false}
                helperText={error.description ? error.description : ''}
                onBlur={validation}
              />
            </Grid>
            <Grid item>
              <Grid container spacing={1}>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    size="medium"
                    color="secondary"
                    className={classes.addBtn}
                    endIcon={<ExpandLessIcon />}
                    onClick={handleAddCredit}
                    disabled={loading}
                  >
                    شارژ
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    variant="contained"
                    fullWidth
                    size="medium"
                    color="secondary"
                    className={classes.removeBtn}
                    endIcon={<ExpandMoreIcon />}
                    onClick={handleCreditDeduction}
                    disabled={loading}
                  >
                    کسر
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </>
        )}
      </Grid>
    </div>
  );
};

export default React.memo(Wallet);
